import { render, staticRenderFns } from "./TerminAbholung.vue?vue&type=template&id=52f94514"
import script from "./TerminAbholung.vue?vue&type=script&lang=ts"
export * from "./TerminAbholung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports